import { Component, Input } from '@angular/core';
import { IGenericLabelValue } from '@shared/interface/generic';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { UtilitiesService } from '@services/utilities.service';

@Component({
  selector: 'app-text-copy-clipboard',
  styleUrls: ['./text-copy-clipboard.component.scss'],
  template: `
    <div class="me-4 mb-3 d-flex gap-2 w-30">
      <span>{{ text.label }} {{ text.value }}</span>
      <span
        (click)="copyToClipboard(valueToCopy)"
        [inlineSVG]="STRING_CONSTANTS.ICON.IC_COPY"
        [ngbPopover]="popoverText"
        [placement]="'bottom'"
        [popoverClass]="'tooltip-info'"
        class="cursor-pointer"
      ></span>
    </div>
  `,
})
export class TextCopyClipboardComponent {
  @Input() popoverText!: string;
  @Input() text!: IGenericLabelValue;
  @Input() valueToCopy!: string;

  constructor(private utils: UtilitiesService) {}

  copyToClipboard(val: string) {
    return navigator.clipboard.writeText(val);
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
